/* eslint-disable no-undef,sort-keys,quote-props */
const HOST = {
	dev: "",
	test: "//test.d.163.com",
	prod: "//d.163.com"
}[RUN_ENV];
const HOST_GAMEYW = {
	dev: "",
	test: "//cain-dev.gameyw.netease.com",
	prod: "https://cain-api.gameyw.netease.com"
}[RUN_ENV];
const MAP_HERO_CN_EN = {
	"圣教军": "crusader",
	"巫医": "witch-doctor",
	"武僧": "monk",
	"死灵法师": "necromancer",
	"猎魔人": "demon-hunter",
	"野蛮人": "barbarian",
	"魔法师": "wizard"
};
const MAP_HERO_EN_CN = {
	barbarian: "野蛮人",
	crusader: "圣教军",
	"demon-hunter": "猎魔人",
	monk: "武僧",
	necromancer: "死灵法师",
	"witch-doctor": "巫医",
	wizard: "魔法师"
};
const MAP_PROPERTY_EN_CN = {
	barbarian: "怒气",
	crusader: "愤怒",
	"demon-hunter": "憎恨/戒律",
	monk: "内力",
	necromancer: "精魂",
	"witch-doctor": "法力",
	wizard: "奥能"
};
const PROPERTY_TEXT = {
	"伤害": "伤害：x\n你每秒可以造成的伤害量。\n你的武器、属性、攻速、暴击率、暴击伤害、被动技能以及双持攻速增加会影响伤害。",
	"体能": "体能：x\n提高生命值以承受更多伤害。\n每1点体能可以使生命值提高10点。",
	"内力": "内力：x/x\n由武僧近战攻击和某些技能所产生。\n内力是一种珍贵的能量，用于施展威力强大的防御和攻击性招式。",
	"力量": "力量：x\n野蛮人和圣教军的主属性。\n使野蛮人和圣教军的所有伤害提高a%。\n使护甲值提高x点。",
	"坚韧": "坚韧：x\n你能承受的原始伤害总量。\n生命值上限、护甲值、躲闪几率、平均抗性、远程近战与精英伤害减免会影响坚韧。",
	"奥能": "奥能：x/x\n一种快速恢复的能量。\n用于施放大多数的魔法师法术。",
	"怒气": "怒气：x/x\n野蛮人使用怒气生成技。\n或受到伤害时即会产生怒气。\n用于实战野蛮人威力更强的攻击招式。",
	"恢复": "恢复：x\n你在战斗中每秒可以恢复的坚韧数值。\n影响恢复的因素包括：你的坚韧、每次命中恢复的生命、每秒恢复的生命值、生命偷取、每消耗1点怒气/内力/愤怒值恢复的生命值、每次消灭恢复的生命值以及生命球治疗加成。",
	"愤怒": "愤怒：x/x\n圣教军的力量源泉，使用它释放攻击技能。",
	"憎恨/戒律": "憎恨：x/x\n一种快速恢复的能量。\n用于施放猎魔人的攻击性技能。\n戒律：y/y\n一种持续慢速恢复的能量。\n用于施放猎魔人的战术技能。",
	"敏捷": "敏捷：x\n猎魔人和武僧的主属性。\n使猎魔人和武僧的所有伤害提高a%。\n使护甲值提高x点。",
	"智力": "智力：x\n巫医、魔法师和死灵法师的主属性。\n使巫医、魔法师和死灵法师的所有伤害提高a%。\n使抗性提高b点。",
	"法力": "法力：x/x\n巫医消耗法力值来施展他的大多数法术技能。\n法力池会随着巫医等级的提升而增长。",
	"生命值": "生命值上限：x\n如果你失去所有生命值即会死亡。\n体能、物品和技能可以提高生命值。",
	"精魂": "精魂：x/x\n死灵法师使用精魂强化自身。并使用精魂施放攻击性技能。"
};
/* eslint-enable */
const INTERFACE = {
	getUser: `${HOST}/api/info`,
	ladderEquip: `${HOST_GAMEYW}/worldhero-web/app_api/allItem`,
	ladderHero: `${HOST_GAMEYW}/worldhero-web/app_api/heroDetail`,
	ladderOption: `${HOST_GAMEYW}/worldhero-web/app_api/queryConfig`,
	ladderRanking: `${HOST_GAMEYW}/worldhero-web/app_api/mystic`,
	ladderRecord: `${HOST_GAMEYW}/worldhero-web/app_api/mysticWorldMax`,
	ladderSync: `${HOST_GAMEYW}/cain/diabloReSyncBattleTag/reSyncBattleTag`,
	ladderTarget: `${HOST_GAMEYW}/worldhero-web/hero/list`,
	login: `${HOST}/api/loginByCookie`,
	logout: `${HOST}/api/logout`,
	setNickname: `${HOST}/api/regDiscuz`
};
const LINK = {
	equip: "http://content.battlenet.com.cn/d3/icons-zh-cn/items/large",
	gem: "http://content.battlenet.com.cn/d3/icons-zh-cn/items/small",
	power: "//d.163.com/cn/js/tooltip",
	skill: "http://content.battlenet.com.cn/d3/icons-zh-cn/skills/64"
};
const MAP_HERO_ID_CN = {
	1: "野蛮人",
	2: "巫医",
	3: "武僧",
	4: "魔法师",
	5: "猎魔人",
	6: "圣教军",
	10: "死灵法师"
};
const MAP_HERO_ID_EN = {
	1: "barbarian",
	2: "witch-doctor",
	3: "monk",
	4: "wizard",
	5: "demon-hunter",
	6: "crusader",
	10: "necromancer"
};
const MAP_SERVER_EN_CN = {
	cn: "国服",
	eu: "欧服",
	tw: "亚服",
	us: "美服"
};
const MAP_SERVER_EN_ID = {
	cn: 0,
	eu: 3,
	tw: 1,
	us: 2
};
const MAP_SLOT_EN_CN = {
	bracers: "护腕",
	feet: "足部",
	hands: "手套",
	head: "头部",
	leftFinger: "左手指",
	legs: "腿部",
	mainHand: "主武器",
	neck: "颈部",
	offHand: "副武器",
	rightFinger: "右手指",
	shoulders: "肩部",
	torso: "胸部",
	waist: "腰部"
};
const REGEXP = {
	nickname: /^[\u0391-\uFFE5A-Za-z]+$/,
	nicknameCn: /^[\u0391-\uFFE5]{3,7}$/,
	nicknameEn: /^[A-Za-z]{3,15}$/
};
const URS_CONFIG = {
	bgpTime: 1e4,
	bgpTime2: 1e4,
	defaultUnLogin: 1,
	host: "d.163.com",
	includeBox: "js_N_login_wrap",
	isHttps: 1,
	mailloginclause: {
		list: [{
			txt: "《凯恩之角用户协议》",
			url: "https://d.163.com/webapp/cain-exemption"
		}, {
			txt: "《凯恩之角隐私政策》",
			url: "https://d.163.com/webapp/user-terms/privacy-policy.html"
		}]
	},
	needPrepare: 0,
	needQrLogin: 0,
	needUnLogin: 1,
	newCDN: 1,
	page: "login",
	placeholder: { account: "请输入邮箱地址", pwd: "6-16位密码，区分大小写" },
	product: "cainscorner",
	productKey: "2a366a8aec494ba4906080a612d57e83",
	promark: "SuaKwhM",
	regUrl: "//zc.reg.163.com/regInitialized?pd=cainscorner&pkid=IESilNT&pkht=d.163.com",
	single: 1,
	skin: 3,
	swidth: 250,
	version: 3
};
const URS_STYLE = ".g-bd,.m-header{position:relative}body{padding:0}.g-bd{overflow:hidden;border-radius:4px;width:320px;background:0 0}.m-cnt .inputbox,.u-loginbtn{border-radius:5px}.m-header{display:none;padding-bottom:20px}.m-cnt{padding:0 25px;width:270px;-webkit-user-select:none}.m-cnt .u-logo div{margin-top:8px}.m-cnt .un-login{background-color:#fff}.m-cnt .u-input input{width:175px;font-size:14px}.m-cnt .ckin{width:135px}.m-cnt #login-form .m-ckcnt input.cktext{width:85px}.m-cnt .m-sug{width:268px}.m-cnt .m-nerror .ferrorhead,.m-cnt .m-nerror .ferrorhead2{width:250px}.fail0,.fail1{top:34px}.w-exception{width:320px}.u-btn-middle3{width:95px;font-size:14px}.m-footer{padding:10px 50px}.m-cnt .statusTxt .u-success{margin-top:3px}.fur-vip{position:absolute;left:30px;top:61px;z-index:999;width:320px;height:226px;background:url(../images/vip.jpg) no-repeat}.u-loginbtn{margin:0 auto;width:170px;height:40px;line-height:40px;font-size:14px}.f-bgcolor{background-color:#13a654}.btncolor{background-color:#cf1f2a;color:#fff}.btncolor:active,.btncolor:hover,.btndisabled,.btndisabled:active,.btndisabled:hover{background-color:#fd5562;color:#fff}.btndisabled{cursor:default}";

export {
	HOST,
	HOST_GAMEYW,
	INTERFACE,
	LINK,
	MAP_HERO_CN_EN,
	MAP_HERO_EN_CN,
	MAP_HERO_ID_CN,
	MAP_HERO_ID_EN,
	MAP_PROPERTY_EN_CN,
	MAP_SERVER_EN_CN,
	MAP_SERVER_EN_ID,
	MAP_SLOT_EN_CN,
	PROPERTY_TEXT,
	REGEXP,
	URS_CONFIG,
	URS_STYLE
};